/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Error_UnsupportedInputs */

const vi_file_upload_error_unsupported = /** @type {(inputs: File_Upload_Error_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sai định dạng tệp. Chỉ nhận JPG, PNG, WEBP, MP4, WEBM.`)
};

/**

* @param {File_Upload_Error_UnsupportedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const file_upload_error_unsupported = /** @type {((inputs?: File_Upload_Error_UnsupportedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Error_UnsupportedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_file_upload_error_unsupported(inputs)
});